import React from 'react'

const Fail = () => {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1569_19686)">
        <path
          d="M39.8957 8.4375C48.2942 8.4375 56.3487 11.7738 62.2874 17.7125C68.226 23.6511 71.5623 31.7056 71.5623 40.1042V40.1042C71.5623 48.5027 68.226 56.5572 62.2874 62.4959C56.3487 68.4345 48.2942 71.7708 39.8957 71.7708V71.7708C31.4971 71.7708 23.4426 68.4345 17.504 62.4959C11.5653 56.5572 8.229 48.5027 8.229 40.1042V40.1042C8.229 31.7056 11.5653 23.6511 17.504 17.7125C23.4426 11.7738 31.4971 8.4375 39.8957 8.4375V8.4375Z"
          fill="url(#paint0_radial_1569_19686)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M39.8961 10.0375C31.9219 10.0375 24.2743 13.2053 18.6357 18.8438C12.9971 24.4824 9.82939 32.13 9.82939 40.1042C9.82939 48.0784 12.9971 55.7259 18.6357 61.3645C24.2743 67.0031 31.9219 70.1709 39.8961 70.1709C47.8702 70.1709 55.5178 67.0031 61.1564 61.3645C66.795 55.7259 69.9627 48.0784 69.9627 40.1042C69.9627 32.13 66.795 24.4824 61.1564 18.8438C55.5178 13.2053 47.8702 10.0375 39.8961 10.0375ZM16.373 16.5811C22.6117 10.3424 31.0732 6.83752 39.8961 6.83752C48.7189 6.83752 57.1804 10.3424 63.4191 16.5811C69.6579 22.8198 73.1627 31.2813 73.1627 40.1042C73.1627 48.9271 69.6579 57.3886 63.4191 63.6273C57.1804 69.866 48.7189 73.3709 39.8961 73.3709C31.0732 73.3709 22.6117 69.866 16.373 63.6273C10.1343 57.3886 6.62939 48.9271 6.62939 40.1042C6.62939 31.2813 10.1343 22.8198 16.373 16.5811Z"
          fill="url(#paint1_radial_1569_19686)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M53.1313 26.8687C53.7561 27.4935 53.7561 28.5066 53.1313 29.1314L29.1313 53.1314C28.5064 53.7562 27.4934 53.7562 26.8685 53.1314C26.2437 52.5066 26.2437 51.4935 26.8685 50.8687L50.8685 26.8687C51.4934 26.2438 52.5064 26.2438 53.1313 26.8687Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.8685 26.8687C27.4934 26.2438 28.5064 26.2438 29.1313 26.8687L53.1313 50.8687C53.7561 51.4935 53.7561 52.5066 53.1313 53.1314C52.5064 53.7562 51.4934 53.7562 50.8685 53.1314L26.8685 29.1314C26.2437 28.5066 26.2437 27.4935 26.8685 26.8687Z"
          fill="white"
        />
      </g>
      <defs>
        <radialGradient
          id="paint0_radial_1569_19686"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(87.459 88.3642) rotate(-134.873) scale(131.193 446.292)"
        >
          <stop stopColor="#E60000" />
          <stop offset="1" stopColor="#9C2AA0" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_1569_19686"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(89.8626 90.8026) rotate(-134.873) scale(137.822 468.842)"
        >
          <stop stopColor="#E60000" />
          <stop offset="1" stopColor="#9C2AA0" />
        </radialGradient>
        <clipPath id="clip0_1569_19686">
          <rect width="80" height="80" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Fail
